"use client";

import { Suspense } from "react";
import { useSearchParams } from "next/navigation";
import { Button } from "@/components/ui/button";
import { Text } from "@/components/ui/text";


const ERROR_MESSAGES: Record<string, string> = {
  auth_failed: "Authentication failed. Please try again.",
  invalid_state: "Security check failed. Please try again.",
  missing_params: "Invalid callback. Please try again.",
  missing_verifier: "Session expired. Please try again.",
  server_error: "An unexpected error occurred. Please try again.",
};

function LoginContent() {
  const searchParams = useSearchParams();
  const error = searchParams.get("error");
  const redirectUrl = searchParams.get("redirect_url");
  const errorMessage = error ? ERROR_MESSAGES[error] ?? error : null;

  const loginHref = redirectUrl
    ? `/api/auth/login?redirect_url=${encodeURIComponent(redirectUrl)}`
    : "/api/auth/login";

  return (
    <>
      <div className="space-y-3">
        <Button asChild size="lg" className="w-full text-base">
          <a href={loginHref}>Continue at TCLA Forum</a>
        </Button>
      </div>

      {errorMessage ? (
        <p className="mt-4 text-center text-sm text-destructive">
          {errorMessage}
        </p>
      ) : null}
    </>
  );
}

export default function LoginPage() {
  return (
    <main className="min-h-screen bg-paper text-ink">
      <div className="mx-auto flex min-h-screen w-full items-center px-6 py-12">
        <div className="mx-auto w-full max-w-sm">
          <header className="mb-8 text-center">
            <Text as="h1" variant="heading-1">
              Account required
            </Text>
            <p className="mt-2 text-[15px] text-ink-3">
              This feature requires a TCLA account.
            </p>
          </header>

          <Suspense>
            <LoginContent />
          </Suspense>
        </div>
      </div>
    </main>
  );
}
